import { h, Component, Fragment } from "preact";
import PageDataFeed from "../../../services/page-data-feed";
import User from "../../../services/user";
import { msg } from "@lingui/core/macro";
import { MarketingEvents } from "../../../utils/gtm-module";


export default class Session extends Component {
    static data = {};
    static errors = {};
    statusInterval = null;

    componentWillMount() {
        if (!this.statusInterval) {
            this.statusInterval = setInterval(() => this.reloadSessionStatus(), 30000);
        }

        Session.errors = {
            'login-wrong-credentials': window.Translation(msg`Credenziali Errate`),
            'logout-failed': window.Translation(msg`Logout Fallito`),
            'session-expired': window.Translation(msg`Sessione Scaduta`),
            'link-sent': {
                error: 'link-sent',
                msg: window.Translation(msg`A link has been sent to your phone. Click the link to verify your account`)
            }
        };
    }

    componentWillUnmount() {
        clearInterval(this.statusInterval);
    }

    reloadSessionStatus() {
        const wasAlreadyLogged = User.data !== false;
        Session.checkStatusPromise()
            //> Sessione scaduta
            .catch(e => {
                if (wasAlreadyLogged) {
                    //console.warn(e);
                    User.data = false;
                    PageDataFeed.rerender();
                }
            })
            //> Sessione OK
            .then(user => {
                if (!!user && !wasAlreadyLogged) {
                    PageDataFeed.rerender();
                }
            });
    }

    static store(name, value) {
        this.data[name] = value;
        return this;
    }

    static fetch(name = null) {
        if (!User.data) {
            return null;
        }

        const sessiondata = {...User.data, ...this.data};

        if (name === null) {
            return sessiondata;
        }

        return !!sessiondata[name]? sessiondata[name] : null;
    }

    static async loginPromise(username, password) {
        try {
            const UserData = await PageDataFeed.user.login(username, password);

            if (!!User.isAffiliate()) {
                await User.fetchAffiliateAmounts();
            }

            if (!!UserData) {
                window.dispatchEvent(new Event(MarketingEvents.LOGIN));
            }
            return UserData;
        } catch (e) {
            throw Session.errors[e.error] || e.error;
        }
    }

    static async logoutPromise() {
        const Logout = await PageDataFeed.user.logout();

        if (!!Logout.error) {
            throw Session.errors[Logout.error] || Logout.error;
        }

        return Logout;
    }

    static async checkStatusPromise() {
        const Status = await PageDataFeed.user.isSessionOpen();

        if (!!Status.error) {
            throw Session.errors[Status.error] || Status.error;
        }

        if (!!User.isAffiliate()) {
            await User.fetchAffiliateAmounts();
        }

        return Status;
    }

    static isActive() {
        return User.isLogged();
    }
}